export enum ReportParameters {
  DateType = 'DateTypeParam',
  StartDate = 'StartDate',
  EndDate = 'EndDate',
  FacilityID = 'FID',
  ParentFacilityID = 'PFID',
  ParentFacilityName = 'ParentFacilityParam',
  FacilityName = 'FacilityNameParam',
  PopTreatID = 'PopTreatID',
  ProgramID = 'ProgramID',
  PopulationTypeID = 'PopulationTypeID',
  TreatmentTypeID = 'TreatmentTypeID',
  StartMonth = 'StartMonth',
  StartYear = 'StartYear',
  EndMonth = 'EndMonth',
  EndYear = 'EndYear',
  AccountID = 'AID',
}
